<template>
  <div :class="['row mx-0', addContainerClasses]">
    <div class="col-12 col-md-4 col-xl-3 pb-3 font-weight-bold pt-2" v-html="title" />
    <div class="col-12 col-md-8 col-xl-9">
      <div class="row pt-2">
        <div class="col-12 col-lg-6">
          <span class="d-block pb-2">Mineralwolleplatten</span>
          <div class="d-flex flex-column align-items-start align-items-xl-start flex-sm-wrap flex-sm-row">
            <button type="button"
              v-for="(item, index) in items.bar"
              :key="'bar-' + index"
              :class="['btn btn-sm btn-outline-filter', filterUiState('pinsulation', item.value)]"
              v-on:click="selectValue(item.value)">{{ item.title }}</button>
          </div>
        </div>
        <div class="col-12 col-lg-6">
          <span class="d-block pb-2">Weichfaserplatten</span>
          <!-- <span class="d-block pb-2">Brett&shy;stapel&shy;decke, genagelt</span> -->
          <div class="d-flex flex-column align-items-start align-items-xl-start flex-sm-wrap flex-sm-row">
            <button type="button"
              v-for="(item, index) in items.board"
              :key="'board-' + index"
              :class="['btn btn-sm btn-outline-filter', filterUiState('pinsulation', item.value)]"
              v-on:click="selectValue(item.value)">{{ item.title }}</button>
          </div>
        </div>
      </div>

        
      <div class="row pt-2">

        <div class="col-12">
          <span class="d-block pb-2">Polystyrol</span>
          <!-- <span class="d-block pb-2">Brett&shy;stapel&shy;decke, genagelt</span> -->
          <div class="d-flex flex-column align-items-start align-items-xl-start flex-sm-wrap flex-sm-row">
            <button type="button"
              v-for="(item, index) in items.pol"
              :key="'pol-' + index"
              :class="['btn btn-sm btn-outline-filter', filterUiState('pinsulation', item.value)]"
              v-on:click="selectValue(item.value)">{{ item.title }}</button>
          </div>
        </div>

        
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import { trackCallstack } from '../../../helper/tracker'

export default {
  name: 'StoCscFilterSectionPinsulation',
  props: {
    addContainerClasses: String
  },
  data: function () {
    return {
      title: 'Dämmung',
      items: {
        bar: [
          { title: '40 mm Sto-Speedlamelle Typ ll', value: 'msp-40' },
          { title: '50 mm Sto-Speedlamelle Typ ll', value: 'msp-50' },
          { title: '60 mm Sto-Speedlamelle Typ ll', value: 'msp-60' },
          { title: '100 mm Sto-Speedlamelle Typ ll', value: 'msp-100' },
          { title: '60 mm Sto-Steinwolleplatte 2/B/H4 W5', value: 'mst-60' },
          { title: '100 mm Sto-Steinwolleplatte 2/B/H4 W5', value: 'mst-100' }
        ],
        board: [
          { title: '60 mm Sto-Weichfaserplatte 039 VHF', value: 'wvhf-60' },
          { title: '80 mm Sto-Weichfaserplatte 039 VHF', value: 'wvhf-80' },
          // { title: '60 mm Sto-Weichfaserplatte M042', value: 'wmo42-60' },
          { title: '80 mm Sto-Weichfaserplatte M042', value: 'wmo42-80' },
          { title: '60 mm Sto-Weichfaserplatte M046', value: 'wmo46-60' },
          { title: '60 mm Sto-Weichfaserplatte M050', value: 'wmo50-60' }
        ],
        pol: [
          { title: '100 mm Sto-Dämmplatte Top 32', value: 'pda-100' },
          { title: '140 mm Sto-Dämmplatte Top 32', value: 'pda-140' }
        ]
      }
    }
  },
  computed: {
    ...mapGetters({
      filterUiState: 'filter/uiState',
      filterState: 'filter/state'
    })
  },
  methods: {
    selectValue: function (value) {
      let title = ''
      let result = this.items.bar.filter(item => item.value === value)
      if (result.length <= 0) result = this.items.board.filter(item => item.value === value)
      if (result.length <= 0) result = this.items.pol.filter(item => item.value === value)
      if (result.length > 0) title = result[0].title

      const uiState = this.filterUiState('pinsulation', value)

      

      let category = this.title
      if (this.items.bar.some(el => el.value === value)) {
          category += '-Mineralwolleplatten'
      }
      else if ( this.items.board.some(el => el.value === value)) {
          category += '-Weichfaserplatten'
      }
      else if ( this.items.pol.some(el => el.value === value)) {
          category += '-Polystyrol'
      }


      this.$gtm.trackEvent({
        event: 'filter',
        category: category,
        action: uiState === 'pending' ? 'hinzufügen' : (uiState === 'active' ? 'reaktivieren' : 'aktivieren'),
        label: title,
        value: value
      })

      this.$store.dispatch('filter/setValue', {
        name: 'pinsulation',
        title: category + ' ' + title,
        value: value
      }).then(() => trackCallstack(this.$gtm, this.filterState._callstack))
    }
  }
}

</script>
